import { CheckCircleFilled } from "@ant-design/icons";
import { Spin } from "antd";
import styles from "./EhrSync.module.scss";
import { SYNC_RUNNING, resultLine } from "./copy";
import type { UseEhrSync } from "./useEhrSync";

/**
 * One-line status strip above the patient list, present only while a sync is in
 * flight and for a few seconds after it lands. Same surface as PatientSyncNotice
 * (blue card, indigo text) at a fraction of the height; failures go out as toasts
 * from the hook, so this only ever says "working" or "done".
 */
const EhrSyncStatus = ({ sync }: { sync: UseEhrSync }) => {
  const { phase, run } = sync;
  if (phase !== "running" && phase !== "ok") return null;

  const isRunning = phase === "running";
  return (
    <div className={styles.strip} role="status" aria-live="polite">
      {isRunning ? <Spin size="small" /> : <CheckCircleFilled className={styles.check} aria-hidden="true" />}
      <span className={styles.stripText}>{isRunning ? SYNC_RUNNING : resultLine(run)}</span>
      {isRunning && <span className={styles.progress} aria-hidden="true" />}
    </div>
  );
};

export default EhrSyncStatus;
